import { persist } from 'zustand/middleware';
import { createStore } from 'zustand/vanilla';
const COOKEIS_STORE_VERSION = 2;
const CookiesStore = createStore()(persist((set, get) => ({
    isCookiesAccepted: false,
    acceptCookies: () => set({
        isCookiesAccepted: true,
    }),
}), { name: 'cookies_agreement', version: COOKEIS_STORE_VERSION }));
export { CookiesStore };
